import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import MarketCaptureChart from "../../../ceo/analysis/competitive/charts/market-capture";
import HelpIconButtonWithTooltip from "../../../ui-building-blocks/icons/HelpIconButtonWithTooltip";
import Teams from "../../../../api/Teams";

class TeamReportsSection4Step2 extends PureComponent {
  get left_content() {
    const { total_demand, endingInventory } = this.props;
    const team = Teams.currentTeam();
    const team_id = team ? team.id : 0;
    const overallMarketDemand = (
      ((Math.abs(this.getDataValue(team_id, "Units Sold Auto")) +
        Math.abs(this.getDataValue(team_id, "Units Sold Mobile"))) /
        total_demand.total) *
      100
    ).toFixed(2);

    return (
      <span>
        In this round, the market demanded{" "}
        <AbbreviatedMillionNumberFormat
          value={total_demand.total}
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        units of image sensors, and your team was able to capture{" "}
        {overallMarketDemand}% of the overall market demand. You had{" "}
        <AbbreviatedMillionNumberFormat
          value={endingInventory}
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        units of inventory remaining.
        <br />
        <br />
        To learn more about what impacts your sales, please review the following
        content:
        <br />
        <TypeformLink title="STP" url={TypeformUrls.STP} />
        <TypeformLink
          title="Marketing Mix"
          url={TypeformUrls.MARKETING_MIX}
          className="link-with-margin"
        />
        <TypeformLink
          title="Product Market Fit"
          url={TypeformUrls.PRODUCT_MARKET_FIT}
          className="link-with-margin"
        />
      </span>
    );
  }

  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    const val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  }

  get dataMobile() {
    const { teams } = this.props;
    let chartData = [];

    Object.keys(teams).forEach(team_id => {
      chartData.push({
        team: teams[team_id],
        value: Math.abs(this.getDataValue(team_id, "Units Sold Mobile"))
      });
    });

    return chartData;
  }

  get dataAuto() {
    const { teams } = this.props;
    let chartData = [];

    Object.keys(teams).forEach(team_id => {
      chartData.push({
        team: teams[team_id],
        value: Math.abs(this.getDataValue(team_id, "Units Sold Auto"))
      });
    });

    return chartData;
  }

  get right_content() {
    const { total_demand } = this.props;

    return (
      <div>
        <div className="pt-30 pl-30 pr-30">
          <h5>
            MARKET CAPTURE - MOBILE
            <HelpIconButtonWithTooltip
              category="Market Capture Mobile"
              tooltipContent="This section shows the # of units you were able to sell in the market in relation to your competitors."
              iconSize="sm"
            />
          </h5>
          <hr />
        </div>
        <MarketCaptureChart
          data={this.dataMobile}
          totalDemand={total_demand.mobile}
        />
        <div className="pt-30 pl-30 pr-30">
          <h5>
            MARKET CAPTURE - AUTO
            <HelpIconButtonWithTooltip
              category="Market Capture Auto"
              tooltipContent="This section shows the # of units you were able to sell in the market in relation to your competitors."
              iconSize="sm"
            />
          </h5>
          <hr></hr>
        </div>
        <MarketCaptureChart
          data={this.dataAuto}
          totalDemand={total_demand.auto}
        />
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Market Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection4Step2;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-4/step-2.js